var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video",style:(_vm.style),attrs:{"src":_vm.value.video,"controls":_vm.value.controls,"autoplay":_vm.value.autoplay,"loop":_vm.value.loop,"poster":_vm.value.poster},domProps:{"muted":_vm.value.muted}})
}
var staticRenderFns = []

export { render, staticRenderFns }